<template>
  <div
    class="c-aed-editableTextArea"
    :class="{
      active: isEditing,
      'c-aed-editableDropdown--textAligned': textAligned
    }"
    :ref="_uid"
  >
    <textarea
      class="c-aed-editableTextArea__input "
      type="text"
      v-model="mutableValue"
      :placeholder="translationsCustom.addValue || '-'"
      @input="valueChange($event)"
      v-on:focus="handleFocus"
      @blur="submitIfLeave"
      :maxlength="maxLength"
    />
    <div
      class="c-aed-editableTextArea__editable-icon o-button o-button--light-blue o-button--action o-button--square"
      v-if="!isEditing"
    >
      <svg class="o-svg-icon" viewBox="0 0 64 64" type="image/svg+xml">
        <use xlink:href="spritemap.svg#sprite-edit" x="0" y="0"></use>
      </svg>
    </div>
    <button
      class="o-button o-button--action o-button--round"
      v-if="isEditing && canSubmit"
      @click="save"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-check-thinline" x="0" y="0"></use>
      </svg>
    </button>
    <button
      class="o-button o-button--action o-button--round o-button--light"
      v-if="isEditing && canCancel"
      @click="cancel"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-cross" x="0" y="0"></use>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-aed-editableTextArea",
  data() {
    return {
      isEditing: false,
      mutableValue: "",
      isValid: true
    };
  },
  props: {
    section: { required: true },
    name: { required: true },
    initialValue: { required: true },
    haveToSubmit: { type: Boolean, default: false },
    canSubmit: { type: Boolean, default: true },
    editState: { type: Boolean, default: false },
    canCancel: { type: Boolean, default: true },
    textAligned: { type: Boolean, default: false },
    maxLength: { type: Number, default: 1023 },
    storeModule: { type: String, default: "aed" }
  },
  computed: {
    ...mapState("translations", {
      translationsCustom: "custom"
    })
  },
  created() {
    this.mutableValue = this.initialValue;
    this.isEditing = this.editState;
  },
  watch: {
    initialValue: function(newVal) {
      this.mutableValue = newVal;
    },
    editState: function(newVal) {
      this.isEditing = newVal;
    }
  },
  methods: {
    save() {
      this.isEditing = false;
      if (this.mutableValue !== this.initialValue) {
        let payload = {
          api: this.$api,
          id: this.$store.state[this.storeModule].all.id,
          section: this.section,
          method: "PATCH",
          data: {
            [this.name]: this.mutableValue
          }
        };

        this.$store.dispatch(`${this.storeModule}/setSection`, payload);
      }
    },
    cancel() {
      this.isEditing = false;
      this.error = false;
      this.mutableValue = this.initialValue;
      this.$emit("valueReset");
    },
    valueChange(value) {
      this.error = false;
      this.$emit("valueChange", value);
    },
    onClickOutside(event) {
      event.stopPropagation();

      if (this.$refs[this._uid] === event.target.parentElement) return;
      this.canSubmit && this.isValid && this.isEditing && this.save();
    },
    submitIfLeave(event) {
      if (
        this.$refs[this._uid] ===
        (event.relatedTarget && event.relatedTarget.parentElement)
      )
        return;
      if (this.isValid) {
        this.canSubmit && this.isEditing && this.save();
      } else {
        this.isEditing && this.cancel();
      }
    },
    handleFocus() {
      this.isEditing = true;
      document.addEventListener("mousedown", this.onClickOutside);
    }
  }
};
</script>
<style lang="scss">
.c-aed-editableTextArea {
  $root: &;
  $input-left-padding: 10px;
  display: flex;
  position: relative;
  width: 100%;

  &--textAligned {
    margin-left: -$input-left-padding;
    width: calc(100% + 10px); //TODO INTERPOLATION does not work
  }

  &__input {
    border: none;
    vertical-align: middle;
    border: 1px solid transparent;
    flex: 1 1 100%;
    width: 100%;
    @include setStyles("15", $s-typography-sizes);
    line-height: 17px;
    resize: none;
    height: 165px;
    padding: toRem(5px $input-left-padding);

    &::placeholder {
      font-style: italic;
    }

    + .o-button {
      margin-left: 7px;
    }
  }

  &:not(.active) {
    #{$root}__input {
      text-overflow: ellipsis;
    }
  }

  &:hover {
    #{$root}__input {
      border: 1px solid $s-cp-neutral-600;
    }
    div#{$root}__editable-icon {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &.active {
    #{$root}__input {
      border: 1px solid $s-cp-neutral-600;

      &:focus {
        outline: $s-cp-sup-focus auto 1px;
      }
    }
  }

  div#{$root}__editable-icon {
    display: none;
    pointer-events: none;
  }

  .o-button {
    flex: 0 0 auto;
    + .o-button {
      margin-left: 5px;
    }
  }
}
</style>
